import { h } from 'preact'

interface FabProps {
  label: string
  onClick: () => void
}

/**
 * Custom chat-bubble glyph at 24px. Emoji rendered inconsistently across
 * platforms (Apple's bubble is blue, Windows' is monochrome, Android's
 * green) and couldn't inherit color — replaced with a single-color SVG
 * that picks up `currentColor` from the FAB's accent-contrast variable.
 */
function ChatBubbleIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Fab({ label, onClick }: FabProps) {
  return (
    <button type="button" class="fab" aria-label={label} title={label} onClick={onClick}>
      <ChatBubbleIcon />
    </button>
  )
}
